/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import scalefieldLogo from '../../assets/images/scalefield_logo_white.svg';
import { BasicRoutes } from '../../constants/basicRoutes';
import { Namespaces } from '../../i18n';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
import { createNotFoundPageStyles } from './NotFoundPage.styles';

type NotFoundPageProps = {
  code?: 404 | 403;
  redirectLink?: string;
};

export const NotFoundPage = memo<NotFoundPageProps>(props => {
  const { code = 404, redirectLink = BasicRoutes.HOME } = props;
  const classes = createNotFoundPageStyles();
  const { t } = useTranslation(Namespaces.Navigation);

  const description = t([`not_found.code_descriptions.${code}`, 'not_found.code_descriptions.404']);

  useDocumentTitle(`${code} ${description}`);
  return (
    <>
      <Link to="/" className={classes.logoLink}>
        <img src={scalefieldLogo} alt="Logo" className={classes.logoImage} />
      </Link>
      <div className={classes.root}>
        <div className={classes.textBig}>{code}</div>
        <div className={classes.textSmall}>{description}</div>
        <Link to={redirectLink} className={classes.button}>
          <span>{t('not_found.take_me_back')}</span>
        </Link>
      </div>
    </>
  );
});
